(function () {
    if (window.__showroomBrowseLocationsHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.showroomBrowseLocations = window.Branch.showroomBrowseLocations || {};
    window.__showroomBrowseLocationsHasFired = true;

function actionsOnVisible(showroomBrowseLocationsSection, parent){
        console.log('actionsOnVisible showroom browser locations ')
        showroomBrowseLocationsSection.setAttribute('data-interacted', true);
        window.Branch.browseLocations.initBrowseLocationsPopup(showroomBrowseLocationsSection, parent, 'showroom-browse-locations');
    }    

function initImageCarouselCallback(showroomBrowseLocationsSection, parent, type){
        let fromLoad = showroomBrowseLocationsSection.closest('.homepage-content-container') && showroomBrowseLocationsSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(showroomBrowseLocationsSection, parent);
        } else if(!showroomBrowseLocationsSection.closest('.homepage-content-container')) {
            actionsOnVisible(showroomBrowseLocationsSection, parent);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = showroomBrowseLocationsSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                showroomBrowseLocationsSection.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(showroomBrowseLocationsSection, parent);
                showroomBrowseLocationsSection.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.showroomBrowseLocations.showroomBrowseLocationsInitOnLoad = function(type){
        let showroomBrowseLocationsSections = document.querySelectorAll('.showroom-browse-locations:not([data-initialized="true"])');
        showroomBrowseLocationsSections.forEach((showroomBrowseLocationsSection) => {
            let parent = showroomBrowseLocationsSection.closest('.shopify-section');
            showroomBrowseLocationsSection.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                 initImageCarouselCallback(showroomBrowseLocationsSection, parent, type)
            } else {
                 window.Branch.functions.fireOnUserInteraction(initImageCarouselCallback, '.homepage-content-container', showroomBrowseLocationsSection, showroomBrowseLocationsSection, parent);
             }
        })  
    }

    if (document.readyState === "complete") {
        window.Branch.showroomBrowseLocations.showroomBrowseLocationsInitOnLoad('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.showroomBrowseLocations.showroomBrowseLocationsInitOnLoad('regular'));
    }
  })();
